module.exports = __webpack_public_path__ + "static/media/user.7ea4af7d.png";